import Cookies from 'js-cookie'

const TokenKey = 'Shop-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function isLogin() {
  return Cookies.get(TokenKey) !== null && Cookies.get(TokenKey) !== "" && Cookies.get(TokenKey) !== undefined
}



// WEBPACK FOOTER //
// ./src/utils/auth.js